var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"upload-demo",attrs:{"action":_vm.uploadUrl,"on-exceed":_vm.handleExceed,"headers":{
    Authorization: _vm.token,
  },"auto-upload":true,"on-success":_vm.handleSuccess,"on-error":_vm.handleError,"before-upload":_vm.beforeUpload,"show-file-list":false}},[_c('el-button',{style:(_vm.butType.style || ''),attrs:{"type":_vm.butType.type || 'primary',"icon":_vm.butType.icon || 'el-icon-upload2'}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }